import { Component, ViewChild } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-security-alert-modal',
  templateUrl: './security-alert-modal.component.html',
  standalone: true,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, AlertComponent, ModalFooterDirective]
})
export class SecurityAlertModalComponent {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  protected readonly MbsPopupType = MbsPopupType;
}
